import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService, StorageKey, AppearanceMode } from './';
import { AppService } from '../app.service';
import { AppConstants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private currentTheme: AppearanceMode = AppearanceMode.dark;

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private localStorageSvc: LocalStorageService,
    private appSvc: AppService
  ) { }

  initializeTheme(): void {
    const appearanceMode = this.localStorageSvc.getItem<AppearanceMode>(StorageKey.appearanceMode) || AppearanceMode.dark;
    this.setTheme(appearanceMode);
  }

  getCurrentTheme(): AppearanceMode {
    return this.currentTheme;
  }

  setTheme(mode: AppearanceMode): void {
    if (mode === AppearanceMode.light) {
      this.changeToLightMode();
    } else {
      this.changeToDarkMode();
    }
    this.currentTheme = mode;
  }

  changeToDarkMode(): void {
    this.appSvc.removeClasses(this.doc.body.classList, AppConstants.LIGHT_MODE_CLASSES);
    this.appSvc.addClasses(this.doc.body.classList, AppConstants.DARK_MODE_CLASSES);
    this.localStorageSvc.setItem(StorageKey.appearanceMode, AppearanceMode.dark);
    this.currentTheme = AppearanceMode.dark;
  }

  changeToLightMode(): void {
    this.appSvc.removeClasses(this.doc.body.classList, AppConstants.DARK_MODE_CLASSES);
    this.appSvc.addClasses(this.doc.body.classList, AppConstants.LIGHT_MODE_CLASSES);
    this.localStorageSvc.setItem(StorageKey.appearanceMode, AppearanceMode.light);
    this.currentTheme = AppearanceMode.light;
  }

  toggleTheme(): void {
    if (this.currentTheme === AppearanceMode.dark) {
      this.changeToLightMode();
    } else {
      this.changeToDarkMode();
    }
  }
}
